<template>
    <div id="cs-header-menu" class="cs-header-menu-block cs-block cs-no-padding">
        <div class="cs-base-block">
            <CSMenu :menuStyle="data.style" :logo="data.logo" :links="data.links" :menu="menu" />
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex'

    export default {
        name: "Menu",
        components: {
            CSMenu: () => import('../components/CSMenu.vue'),
        },
        data() {
            return {
                menu:{}
            }
        },
        props: {
            data: {
                type: Object,
                default: () => {},
            },
        },
        methods: {},
        mounted() {
            if(data.menu)this.menu = Object.values(data.menu)
        }
    };

</script>

<style lang="scss" scoped>
  @import "../styles/main.scss";
 ::v-deep{
   .cs-nav-primary {
    min-height:72px
   }
 }
</style>